import { Box, Stack, Typography } from "@mui/material";
import HealthScoreBackgroundImage from "../../assets/icons/HealthScoreBackgroundImage";
import React from "react";
import AboutYourHealthScore from "../AboutYourHealthScore";

export interface HealthScoreHeaderProps {
  healthScore?: number;
  title?: string;
  description?: string;
  showInfoLink?: boolean;
}

export default function HealthScoreHeader({
  healthScore,
  title,
  description,
  showInfoLink = false,
}: HealthScoreHeaderProps) {
  return (
    <Box
      component="section"
      p={2}
      pt={4}
      pb={4}
      sx={{
        bgcolor: "primary.900",
        position: "relative",
        width: "100%",
        overflow: "hidden",
        mb: 4,
      }}
    >
      <Box
        sx={{
          position: "absolute",
          top: 0,
          right: 0,
          bottom: 0,
          pointerEvents: "none",
        }}
      >
        <HealthScoreBackgroundImage />
      </Box>
      <Stack gap={2} sx={{ position: "relative", zIndex: 1 }}>
        <Typography variant="h1" color="primary.contrastText">
          {title}
        </Typography>
        <Typography variant="body1" color="primary.contrastText">
          {description}
        </Typography>
        {healthScore && (
          <React.Fragment>
            {showInfoLink && <AboutYourHealthScore healthScore={healthScore} />}
            <Stack gap={1}>
              <Typography
                fontSize={12}
                fontWeight={600}
                color="primary.contrastText"
              >
                {`${healthScore || 0}% complete`}
              </Typography>
              <Box
                sx={{
                  width: "100%",
                  height: 7,
                  bgcolor: "primary.700",
                  borderRadius: "1000px",
                  overflow: "hidden",
                }}
              >
                <Box
                  sx={{
                    width: `${Math.min(100, Math.max(0, healthScore))}%`,
                    height: "100%",
                    bgcolor: "primary.contrastText",
                    borderRadius: "1000px",
                  }}
                />
              </Box>
            </Stack>
          </React.Fragment>
        )}
      </Stack>
    </Box>
  );
}
